

























































import Vue from 'vue'
import { mapGetters } from 'vuex'
import SellerMessage from '~/components/car/classifieds/view/partials/seller/dealer/SellerMessage.vue'
import SellerUserSince from '~/components/car/classifieds/view/partials/seller/dealer/SellerUserSince.vue'
import SellerWorkingHours from '~/components/car/classifieds/view/partials/seller/dealer/SellerWorkingHours.vue'
import SellerBasicInfo from './SellerBasicInfo'
import SellerTelephones from './SellerTelephones'
import CExpandableContent from '~/components/shared/configurable/expand/CExpandableContent.vue'

export default Vue.extend({
  components: {
    SellerMessage,
    OtherShops: () =>
      import(
        '~/components/car/classifieds/view/partials/seller/dealer/OtherShops.vue'
      ),
    SellerWorkingHours,
    SellerUserSince,
    SellerBasicInfo,
    GoogleRating: () =>
      import(
        '~/components/car/classifieds/view/partials/google-rating/GoogleRating.vue'
      ),
    SellerTelephones,
    SellerMiscInfo: () =>
      import(
        '~/components/car/classifieds/view/partials/seller/dealer/SellerMiscInfo.vue'
      ),
    SellerSocialMedia: () =>
      import(
        '~/components/car/classifieds/view/partials/seller/dealer/SellerSocialMedia.vue'
      ),
    CExpandableContent
  },
  props: {
    seller: {
      type: Object,
      required: true
    }
  },
  data: (): { scrolledToMap: boolean } => ({ scrolledToMap: false }),
  computed: {
    ...mapGetters({
      isPlotClassified: 'classifieds/view/isPlotClassified',
      classifiedIsOwn: 'classifieds/view/isOwn'
    }),

    hasSocial() {
      if (this.seller?.social_media) {
        return Object.values(this.seller.social_media).some(social => !!social)
      }
      return false
    }
  }
})
